var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('font-awesome-icon',{class:[_vm.statusVoltage.color],attrs:{"icon":['fas',[_vm.statusVoltage.icon]]}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('report.voltage'))+": "+_vm._s(_vm.voltage + ' V '))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }